import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { shallowEqual } from 'react-redux';
import { ExpandableSection } from '../../components/expandableSection';
import { useAppSelector } from '../../redux/store';
import { PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR } from '../../styles/colors';
import { PanelItem } from '../panelItem';
import { PanelItemDivider } from '../panelItemDivider';
export const SelfTicketsSubPanelContainer = () => {
    const tickets = useAppSelector((state) => state.selfData.fetchedSelfInfo?.tickets, shallowEqual);
    return (_jsx(ExpandableSection, { expandableSectionType: 'self-tickets', colorType: 'player-info', children: !tickets || !Object.keys(tickets).length ? (_jsx(PanelItem, { children: "None" })) : (Object.entries(tickets).map(([ticket, quantity], i) => {
            return (_jsxs(Fragment, { children: [i > 0 ? _jsx(PanelItemDivider, { color: PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR, thicknessPx: 2 }) : null, _jsxs(PanelItem, { children: [_jsx("div", { children: ticket }), _jsx("div", { children: quantity })] })] }, i));
        })) }));
};
